export default "__VITE_ASSET__46aaae27__"